declare namespace $ {

	export class $shm_hitalama_entergate extends $mol_view {
		offline_cleanup( ): any
		Form( ): $shm_hitalama_entergate_form
		title( ): string
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
	type $mol_view__dom_name_shm_hitalama_entergate_form_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_hitalama_entergate_form_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_shm_hitalama_entergate_form_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_hitalama_entergate_form_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['enter_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_hitalama_entergate_form_5 = $mol_type_enforce<
		({ 
			'auth': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_entergate_form_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_hitalama_entergate_form_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['register_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_hitalama_entergate_form_8 = $mol_type_enforce<
		({ 
			'auth': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_view__sub_shm_hitalama_entergate_form_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_entergate_access__value_shm_hitalama_entergate_form_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['access_token'] >
		,
		ReturnType< $shm_hitalama_entergate_access['value'] >
	>
	type $shm_hitalama_entergate_access__submit_shm_hitalama_entergate_form_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['submit'] >
		,
		ReturnType< $shm_hitalama_entergate_access['submit'] >
	>
	type $mol_labeler__title_shm_hitalama_entergate_form_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_entergate_form_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_hitalama_entergate_form_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['mode_field'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_shm_hitalama_entergate_form_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['submit_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_entergate_form_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_shm_hitalama_entergate_form_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['submit_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_view__sub_shm_hitalama_entergate_form_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['actions'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_entergate_form_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_hitalama_entergate_form_20 = $mol_type_enforce<
		({ 
			'display': ReturnType< $shm_hitalama_entergate_form['message_display'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_view__sub_shm_hitalama_entergate_form_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_entergate_form_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['saved_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_string__value_shm_hitalama_entergate_form_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['secret_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_entergate_form_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__submit_shm_hitalama_entergate_form_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__value_shm_hitalama_entergate_form_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['login'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_entergate_form_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__submit_shm_hitalama_entergate_form_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_pick__title_shm_hitalama_entergate_form_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['title'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_entergate_form_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_entergate_form_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_entergate_form_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['saved_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_entergate_form_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_form['saved_enter'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_labeler__title_shm_hitalama_entergate_form_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_entergate_form_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_shm_hitalama_entergate_form_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_entergate_form_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $shm_hitalama_entergate_form extends $mol_view {
		Title( ): $mol_view
		enter_current( ): boolean
		Enter_tab( ): $mol_link
		register_current( ): boolean
		Register_tab( ): $mol_link
		Mode_tabs( ): $mol_view
		access_token( next?: string ): string
		submit( next?: any ): any
		Access_token( ): $shm_hitalama_entergate_access
		Access_label( ): $mol_labeler
		mode_field( ): readonly($mol_view)[]
		Mode_field( ): $mol_view
		submit_title( ): string
		submit_enabled( ): boolean
		Submit( ): $mol_button_major
		actions( ): readonly($mol_view)[]
		Actions( ): $mol_view
		message( ): string
		message_display( ): string
		Message( ): $mol_text
		Saved_accounts_title( ): string
		Saved_label( ): $mol_view
		Saved_icon( ): $mol_icon_dots_vertical
		saved_rows( ): readonly($mol_view)[]
		Saved_list( ): $mol_list
		saved_title( id: any): string
		saved_enter( id: any, next?: any ): any
		secret_key( next?: string ): string
		Secret_key( ): $mol_string
		login( next?: string ): string
		Login( ): $mol_string
		mode( next?: string ): string
		sub( ): readonly(any)[]
		Saved_accounts( ): $mol_pick
		Saved_account( id: any): $mol_button_minor
		Secret_label( ): $mol_labeler
		Login_label( ): $mol_labeler
	}
	
	export class $shm_hitalama_entergate_access extends $mol_string {
		type( ): string
		autocomplete( ): boolean
		attr( ): ({ 
			'autocomplete': string,
			'autofocus': boolean,
		})  & ReturnType< $mol_string['attr'] >
	}
	
}

//# sourceMappingURL=entergate.view.tree.d.ts.map